import { Base } from "../../../base/components/base"
import { Button } from "../../../base/components/native/button"
import { Div } from "../../../base/components/native/div"
import { Input } from "../../../base/components/native/input"
import { EMAIL_REGEX } from "../../../base/helpers/regex"
import { CENTER } from "../../../base/helpers/style"
import { DButton } from '../../shared/d-button'
import { DInput } from '../../shared/d-input'
import { PageTitle } from '../../shared/page-title'

export const LoginForm = () => {
    const base = Base()

    const mainTitle = Div('ورود/ثبت نام با ایمیل')
    const userInput = DInput('ایمیل (به عنوان نام کاربری)', { type: 'email', direction: 'ltr', placeholderAlign: 'right', inputAlign: 'left' })
    const passInput = DInput('رمز ورود (حداقل 8 حرف یا عدد)', { type: 'password', direction: 'ltr', placeholderAlign: 'right', inputAlign: 'left'  })
    const submit = DButton('ورود')
    const message = Div('')
    message.cssClass({ marginTop: '10px', color: 'crimson' })

    base.append(mainTitle,/*  nameTitle, nameInput,  */ userInput, passInput, submit, message)
    userInput.on('input', ()=>{
        userInput.style({
            borderBottom: '1px solid #00000022'
            // Todo: add it to a function: error, normal

        })
    })
    userInput.el.setAttribute('name', 'email')
    submit.el.onclick = () => {
        if (!verify()) return
        submit.el.textContent = 'در حال ورود...'
        submit.el.setAttribute('disabled', '');
        base.emit('request-login', { user: userInput.getValue(), pass: passInput.getValue()/* , name: nameInput.getValue()  */ })
    }

    function verify() {
        message.text('')
        // if (!nameInput.getValue()) {
        //     nameInput.cssClass({
        //         border: '1px solid #ff0000'
        //     })
        //     return false
        // }
        if (!userInput.getValue()) {
            userInput.cssClass({
                borderBottom: '1px solid #ff0000'
            })
            return false
        }
        if (!userInput.getValue().match(EMAIL_REGEX)) {
            userInput.cssClass({
                borderBottom: '1px solid #ff0000'
            })
            message.text('لطفا ایمیل را به درستی وارد کنید')
            return false
        }
        if (!passInput.getValue().match(/\w{8,}/)) {
            passInput.cssClass({
                borderBottom: '1px solid #ff0000'
            })
            message.text('رمز عبور باید حداقل 8 کاراکتر باشد')
            return false
        }
        return true
    }

    mainTitle.cssClass({
        fontSize: '18px',
        letterSpacing: '-.5px',
        marginBottom: '40px'
    })
    userInput.cssClass({ marginBottom: '40px'})
    passInput.cssClass({ marginBottom: '40px'})

    base.cssClass({
        display: 'flex',
        flexDirection: 'column',
        margin: '20px 0',
        backgroundColor: '#f7f7f7',
        padding: '20px',
        borderRadius: '20px',
        border: '1px solid #d6d6d6;'

    })

    return Object.assign(base, {
        failed() {
            message.text('نام کاربری یا رمز عبوراشتباه است.')
            submit.el.textContent = 'ورود'
            submit.el.removeAttribute('disabled');
        },
        done() {
            message.text('')
            submit.el.textContent = 'ورود'
            submit.el.removeAttribute('disabled');
        },
        clear() {
            // nameInput.setValue('')
            userInput.setValue('')
            passInput.setValue('')
            message.text('')
        }
    })
}